/* LMM (2026-07-29): Mengenfeld markiert beim Anklicken seinen Inhalt.

   VORHER live gemessen auf www.leuchtmittelmarkt.com — Feld anklicken, dann "5" tippen:
     Warenkorbseite    Feld "2"  ->  "5"    (Inhalt war markiert, wird ersetzt)
     Collection-Karte  Feld "1"  ->  "15"   (nicht markiert, Ziffer wird angehaengt)

   Die Warenkorbseite kann es, weil ihr Feld in Horizons Komponente sitzt und dort
   on:focus="/selectInputValue" verdrahtet ist; der Handler in
   assets/component-quantity-selector.js ruft schlicht input.select() auf.
   Den LMM-eigenen Mengenfeldern (Cart Drawer, PDP-Kaufbox, PDP-Sticky-Leiste,
   Collection-/Such-Karten, Quick-Add) fehlte nicht die Faehigkeit, sondern nur
   dieser eine Aufruf. Diese Datei zieht ihn nach — kein zweiter, eigener
   Auswahl-Mechanismus, sondern derselbe native Griff.

   Delegiert auf document: focusin steigt auf (im Gegensatz zu focus), deshalb
   ueberlebt der Listener jeden Neuaufbau — PJAX-Filterwechsel, Drawer-Refresh,
   morphSection, Quick-Add. Genau ein Listener fuer den ganzen Shop, dadurch keine
   Mehrfachregistrierung nach Section-Rendering und kein Memory-Leak.

   Bewusst NICHT erfasst:
   - Felder in <quantity-selector-component> / <cart-quantity-selector-component>:
     dort markiert Horizon bereits selbst, ein zweiter Aufruf waere Doppelarbeit.
   - Das Warenkorbseiten-Feld name="updates[]": ebenfalls Horizons Zustaendigkeit,
     steht deshalb gar nicht erst im Selektor. Der Header-Zaehler-, Enter- und
     Drawer-Sync-Stand aus den Auftraegen dieser Woche bleibt unberuehrt.
*/
(function () {
  if (window.__lmmQtySelectInit) return;
  window.__lmmQtySelectInit = true;

  var SELEKTOR = [
    'input[data-lmm-cd-qtyinput]', /* Cart Drawer (type=text) */
    'input[data-lmm-sb-input]',    /* PDP Sticky-Leiste */
    'input[name="quantity"]'       /* PDP-Kaufbox, Collection-/Such-Karten, Quick-Add, Quick-Order */
  ].join(',');

  var FREMD = 'quantity-selector-component,cart-quantity-selector-component';

  function istMengenfeld(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    if (el.disabled || el.readOnly) return false;
    if (!el.matches || !el.matches(SELEKTOR)) return false;
    if (el.closest && el.closest(FREMD)) return false;
    return true;
  }

  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!istMengenfeld(el)) return;
    /* select() ist fuer type=number UND type=text zulaessig — setSelectionRange waere
       es fuer type=number nicht (wirft in Chrome). Deshalb exakt dieser Aufruf,
       derselbe, den Horizon auf der Warenkorbseite verwendet. */
    try { el.select(); } catch (x) {}
  });
})();
